import { FC } from 'react';
import { transImageSrc } from 'base/utils/trans-path';
import { IBannerProps } from 'mod/featureV2/Banner/interface';
import { IBannerImage } from 'mod/featureV2/interface/banner';
import { BannerPlaceholder } from 'mod/featureV2/Banner/BannerPlaceholder';
import cn from 'classnames';
import styles from './index.module.less';

export const BannerLargeImage: FC<IBannerProps<IBannerImage>> = props => {
    const {
        banner,
        width,
        height,
        onClick,
        heightFixed = false,
        largeScreenHeightFixed = true,
    } = props;

    return (
        <BannerPlaceholder
            href={banner.href}
            target={banner.target}
            width={width}
            height={height}
            heightFixed={heightFixed}
            largeScreenHeightFixed={largeScreenHeightFixed}
            aria-label={banner.alt || 'banner'}
            className={cn(styles['bg-image'], 'g-banner')}
            bgColor={banner.bgColor}
            onClick={onClick}
        >
            {banner.large ? (
                <>
                    <div
                        className="g-img-toggle g-img-normal sw-overlay"
                        style={{ backgroundImage: `url(${transImageSrc(banner.src, width, 2)})`, }}
                    />
                    <div
                        className="g-img-toggle g-img-large sw-overlay"
                        style={{ backgroundImage: `url(${transImageSrc(banner.large, width * 2, 2)})`, }}
                    />
                </>
            ) : (
                <div
                    className="g-img-toggle sw-overlay"
                    style={{ backgroundImage: `url(${transImageSrc(banner.src, width, 2)})`, }}
                />
            )}
        </BannerPlaceholder>
    );
};